import React, { memo, useState, useEffect } from "react";

import { Row ,Col,Card,Button,Modal} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import NetworkManager from './NetworkManager';

import CountdownTimer, {
  remaining_time,
} from "components/FullTest/CountdownTimer";
import TestProgress from "components/FullTest/MockOperations/TestProgress";
import QuestionInstruction from "components/FullTest/MockOperations/QuestionInstruction";
import Question from "components/FullTest/Question";
import NextModal from "components/FullTest/MockOperations/Popup/NextModal";
import WaitQuestionAudioFinish from "components/FullTest/MockOperations/Popup/WaitQuestionAudioFinish";
import SubmitSectionModal from "components/FullTest/MockOperations/Popup/SubmitSectionModal";
import SaveAndExitPopup from "components/FullTest/MockOperations/Popup/SaveAndExitPopup";
import TimeoutPopup from "components/FullTest/MockOperations/Popup/TimeoutPopup";

import {
  processDataToSubmit,
  questionTime,
  time_spent,
} from "components/FullTest/MockOperations/SubmitData";
import {
  submitMockQuestionApi,
  saveAndExitApi,
  sectionTimeOutApi,
} from "components/FullTest/ApiCalls";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import NetworkDisconnected from "./Popup/NetworkDisconnected";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const NEXT = 1;
const SUBMIT = 2;
const SAVE_AND_EXIT = 3;
const AUDIO_QUESTIONS = [2, 4, 5, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

const Questions = memo(function Questions({
  mockData,
  mock,
  time,
  questions,
  setSection,
  pending,
  localPending,
  skip,
  currQ,
}) {

  console.log("In the Question CurrQ : ",currQ);
  console.log("Here is the mockData curr_q : ",mockData.curr_q);
  console.log("Here is Questions",questions);
  console.log("Here is Questions Length",questions.length);

  // const [currentQuestion, setCurrentQuestion] = useState(
  //   currQ === 0 ? currQ : mockData.curr_q
  // );
  // const [currentQuestion, setCurrentQuestion] = useState(
  //   pending == 1 ? 0 : mockData.curr_q
  // );
  const intStatus = useSelector((state) => state.intStatus);
  const [isOnline, setIsOnline] = useState(true);
  const [currentQuestion, setCurrentQuestion] = useState(0);

  console.log("curr",currentQuestion);
  console.log(mockData,mock,time,questions,setSection,pending,skip);
  const [timeUp, setTimeUp] = useState(false);
  const [nextModal, setNextModal] = useState(false);
  const [questionAudioFinished, setQuestionAudioFinished] = useState(false);
  const [questionAudioModal, setQuestionAudioModal] = useState(false);
  const [submitSection, setSubmitSection] = useState(false);
  const [saveAndExitModal, setSaveAndExitModal] = useState(false);
  const [userResponse, setUserResponse] = useState(false);
  const [strategy, setStrategy] = useState(1);
  const [reduceSectionTime, setReduceSectionTime] = useState(0);
  const [sectionTime, setSectionTime] = useState(0);
  const [, forceUpdate] = useState();
  // console.log(mockData, mockData.curr_q, "mockData.curr_q");
  // console.log(
  //   mockData,
  //   mock,
  //   time,
  //   questions,
  //   setSection,
  //   pending,
  //   "pending",
  //   skip,
  //   currQ,
  //   "We are in Questions where Current Question is set to currQ or mockData.curr_q"
  // );

  useEffect(() => {
    setCurrentQuestion(0);
    // if (mockData?.curr_q) {
    //   setCurrentQuestion(mockData.curr_q - 1);
    // }
  }, [mockData]);

  useEffect(() => {
    const connection = typeof intStatus === "undefined" ? true : intStatus;
    setIsOnline(connection);
    
    // Retry failed requests when back online
    if (connection) {
      NetworkManager.retryFailedRequests();
    }
  }, [intStatus]);

  useEffect(() => {
    // track time (in seconds) spent on a question.
    questionTime();
  }, [currentQuestion]);

  const submit = (response) => {};

  const showResult = () => {};

  // receive data from subcategory files.
  const nextQuestion = async (response) => {
    setUserResponse(false);
     setNextModal(false);
      setQuestionAudioFinished(false);
    switch (response.data) {
      case "":
        response.data = new Blob(["hello worllllllllllllld"]);
        break;
      case undefined:
        response.data = new Blob(["hello worlppppppppppppd"]);
        break;
      default:
      // do nothing.
    }

    // check if the question is final question of section.
    // if final. submit the section.
    let submit_section = false;
    let rem_time = parseInt(remaining_time);
    let test_pending = 0;
    if (currentQuestion + 1 === questions.length || timeUp) {
      submit_section = true;
      rem_time = nextSectionRemainingTime() * 60; // in seconds. already converting to minutes in backend.

      // if current section is less than listening then mark pending 1.
      // if current section is listening and its timeout then mark pending 0.
      test_pending = skip > 2 ? 0 : 1;
    } else {
      submit_section = updateSubmitSection();
    }

    const prepared_data = processDataToSubmit(
      response,
      strategy,
      questions[currentQuestion],
      mock.question.length,
      mock.id,
      time_spent,
      rem_time,
      skip,
      submit_section,
      // currentQuestion,
      pending ? mockData.curr_q + currentQuestion : currentQuestion,
      test_pending
    );

    if (prepared_data) {
      // reduce time from main timer.
      if ([6, 7, 13].includes(questions[currentQuestion].subcategory_id)) {
        setReduceSectionTime(response.time);
      }

      if (!timeUp) {
        // agar time up nahi hua hai to section ya currect Question yaha se change hoga.
        // otherwise Timout popup ke OK button ko click krke.
        if (submit_section) {
          setSection((prev) => prev + 1);
        } else {
          setCurrentQuestion((prev) => prev + 1); // show next Question.
        }
      } else if (timeUp && skip === 3) {
        // listening section timeout.
        setSection(10);
      }

      // const res = await submitMockQuestionApi(prepared_data);

      try {
         const res = await NetworkManager.submitWithRetry({
          method: 'POST',
          url: 'submit/mock',
          data: prepared_data
        });
        if (submit_section) {
        // Wait a moment then call submitFailed
        setTimeout(() => {
          submitFailed();
        }, 2000);
      }
      } catch (error) {
         console.error("Submission failed, added to retry queue:", error);
      }
    }
  };
  
  const nextQuestionHandler = () => {
  // Trigger submission when timer expires
  setUserResponse(true);
};

  const updateSubmitSection = () => {
    return timeUp ? true : false;
  };

  const testPendingValue = () => {
    return timeUp ? 1 : 0;
  };
 
  // open a confirmation popup.
  const next = (type) => {
    console.log("Next Button was clicked")
    setNextModal(false);
    switch (type) {
      case NEXT:
        submitAndNextQuestion();
        break;
      case SUBMIT:
        submitAndNextSection();
        break;
      case SAVE_AND_EXIT:
        saveAndExit();
        break;
      default:
      // do nothing
    }
  };

  const soundChecked = () => {
    setQuestionAudioFinished(true);
  };

  const submitResponse = () => {
    console.log("Inside the submit response for submitting the current question");
    // userResponse = true. which will return user response data from related file.
    setUserResponse(true);
    setQuestionAudioFinished(false);
  };

  const submitAndNextQuestion = () => {
    console.log("When the type  was NEXT")
    if (
      AUDIO_QUESTIONS.includes(questions[currentQuestion].subcategory_id) &&
      !questionAudioFinished
    ) {
      console.log("The Current Question",currentQuestion);
      // wait question audio to finish.
      setQuestionAudioModal(true);
    } else {
      setNextModal(true);

      // set Question Audio Finished = false
      // setQuestionAudioFinished(false);
    }
  };

  const submitAndNextSection = () => {
    if (
      AUDIO_QUESTIONS.includes(questions[currentQuestion].subcategory_id) &&
      !questionAudioFinished
    ) {
      console.log("This is for the submit ",currentQuestion);
      // wait question audio to finish.
      setQuestionAudioModal(true);
    } else {
      setSubmitSection(true);
    }
  };

  const saveAndExit = () => {
    setSaveAndExitModal(true);
  };

  // save & exit final action.
  const saveTestAndExit = () => {
    const question = questions[currentQuestion];

    let bodyFormData = new FormData();
    bodyFormData.append("q_count", mock.question.length);
    bodyFormData.append("mock_id", mock.id);
    bodyFormData.append("q_time", time_spent);
    bodyFormData.append("complete", 0);
    bodyFormData.append("question_number", question.question_number);
    bodyFormData.append("pending", 1);
    // bodyFormData.append("curr_q", currentQuestion);
     const globalCurrentQuestion = localPending==1
      ? mockData.curr_q + currentQuestion
      : currentQuestion;
      console.log("globalCurrentQuestion",globalCurrentQuestion);
      
    bodyFormData.append("curr_q", globalCurrentQuestion);
    bodyFormData.append("time", remaining_time);

    saveAndExitApi(bodyFormData);

    // // section 6 is for screen which we are showing when user clicks on Save & Exit button.
    setSection(6);
  };

  // at the end of section. store next section's time.
  const nextSectionRemainingTime = () => {
    let time = 0;
    switch (skip) {
      case 1:
        // at the end of speaking section. assign reading section time.
        time = parseInt(mockData.mock.reading_time); // in minutes
        break;
      case 2:
        // at the end of reading section. assign listening section time.
        time = parseInt(mockData.mock.listening_time); // in minutes
        break;
      default:
      // do nothing. we don't need to set time after listening section. Test Finished.
    }
    setSectionTime(time); // in minutes
    return time;
  };

  const sectionTimedOut = async () => {
    console.log("We are inside the timeout Function ->")
     setUserResponse(true);
     setTimeUp(true);
     console.log("First we will call the submit Response for the current question")
    // submitResponse();
     await new Promise(resolve => setTimeout(resolve, 100));
    console.log("Current question was submitted now find the remaining questions");
    // 1
    const ids = questions.slice(currentQuestion);

    const bodyFormData = new FormData();
    bodyFormData.append("mock_id", mockData.mock.id);
    bodyFormData.append("time", nextSectionRemainingTime());
    ids.map((v, k) => {
      if (k !== 0) {
        bodyFormData.append("id[]", `${v.id}-${v.question_number}`);
      }
    });
    bodyFormData.append("skip", skip);

    // unattempted api.
    // sectionTimeOutApi(bodyFormData);
      try {
      await NetworkManager.submitWithRetry({
        method: 'POST',
        url: 'set/mockTime',
        data: bodyFormData
      });
      setTimeout(() => {
      submitFailed();
    }, 2000);
    } catch (error) {
      console.error("Timeout submission failed:", error);
    }
    console.log("Remaining questions of that section was submitted");
    // 2
    // will fetch user response to this file.
  };

//   const submitFailed = async () => {
//   const failedRequests = NetworkManager.getFailedRequests();
//   if (failedRequests.length === 0) return;

//   let formData = new FormData();
  
//   failedRequests.forEach((request, index) => {
//     // Convert FormData to object for processing
//     const requestData = {};
//     for (let [key, value] of request.data.entries()) {
//       if (key === 'file[]') {
//         formData.append('files[]', value);
//       } else {
//         requestData[key] = value;
//         formData.append(`data[${index}][${key}]`, value);
//       }
//     }
//   });

//   try {
//     await NetworkManager.submitWithRetry({
//       method: 'POST',
//       url: 'submitFailed/mock',
//       data: formData
//     });
    
//     // Clear failed requests after successful submission
//     NetworkManager.clearFailedRequests();
//   } catch (error) {
//     console.error("submitFailed API call failed:", error);
//   }
// };

// Add this function in Full Mock Test Questions.jsx
const submitFailed = async () => {
  const failedRequests = NetworkManager.getFailedRequests();
  if (failedRequests.length === 0) return;

  let formData = new FormData();
  
  failedRequests.forEach((request, index) => {
    // NetworkManager stores request objects, need to extract FormData
    const requestFormData = request.data; // This is the FormData object
    
    // Convert FormData entries to the expected format
    for (let [key, value] of requestFormData.entries()) {
      if (key === 'file[]') {
        formData.append('files[]', value);
      } else {
        formData.append(`data[${index}][${key}]`, value);
      }
    }
  });

  try {
    await NetworkManager.submitWithRetry({
      method: 'POST',
      url: 'submitFailed/mock',
      data: formData
    });
    
    // Clear failed requests after successful submission
    NetworkManager.clearFailedRequests();
    console.log("submitFailed API called successfully");
  } catch (error) {
    console.error("submitFailed API call failed:", error);
  }
};


  const endCurrentSectionAndStartNext = () => {
    
    // only close popup and move control to next section.
    setSection((prev) => prev + 1);
  };

  const props_data = {
    submit,
    showResult,
    soundChecked,
    nextQuestion,
    setStrategy,
    data: questions[currentQuestion],
    resultMode: false,
    testMode: true,
    stopRecording: userResponse,
    strategy,
    nextQuestionHandler
  };

  // console.log(questions, "questions");
  // console.log(questions[currentQuestion], "currentQuestion");
  // console.log(currentQuestion, "currentQuestion index");

  return (
    <>
      {/* Network warning - commented for now */}
      {/* {!isOnline && (
        <div className="network-warning">
          <i className="fa fa-wifi"></i>
          Connection lost. Your progress is saved and will sync when reconnected.
          {NetworkManager.getFailedRequestsCount() > 0 && (
            <span> ({NetworkManager.getFailedRequestsCount()} pending)</span>
          )}
        </div>
      )} */}
      
      {/* SectionalTest Style Implementation */}
      <div className="content questionsArea old-design p-0 test_width mock-header-gap" id="test-card">
        <Row>
          <Col xs={12}>
            {/* TestHeader - Same as SectionalTest */}
            <Row className="m-0 test_width">
              <Row
                className="d-flex justify-content-between align-items-center w-100 h-50 mock-header-bg"
                style={{
                  // backgroundColor: "#BFBABB",
                  height: "40px	!important",
                }}
              >
                <Col
                  style={{
                    width: "fit-content",
                    padding: "0",
                  }}
                >
                  <Card.Title tag="h4" className="m-0 mx-2">
                    Language Academy - {mock.title}
                  </Card.Title>
                </Col>
                <Col style={{ width: "fit-content" }}>
                  <div className="text-right questionTime p-2">
                    <div className="timeRemaining">
                      <p>
                        {/* <i className="fa fa-clock-o"></i> */}
                        <span>
                          {/* Time Remaining: */}
                          <CountdownTimer
                            time={time}
                            sectionTimedOut={sectionTimedOut}
                            reduceSectionTime={reduceSectionTime}
                            setReduceSectionTime={setReduceSectionTime}
                          />
                        </span>
                      </p>
                    </div>
                    <TestProgress
              mockData={mockData}
              questions={questions}
              currentQuestion={currentQuestion}
              pending={pending}
              skip={skip}
              localPending={localPending}
            />
                    {/* <div className="item">
                      <p>
                        Question {currentQuestion + 1} of {questions.length}
                      </p>
                    </div> */}
                  </div>
                </Col>
              </Row>
              <Row
                style={{
                  backgroundColor: "#0081A4",
                  minHeight: "40px",
                }}
                className="d-flex justify-content-end align-items-center px-4"
              >
                <div className="d-flex justify-content-end gap-3">
                  {/* <i className="fa fa-expand text-white" style={{ cursor: "pointer" }}></i>
                  <i className="fa fa-moon-o text-white" style={{ cursor: "pointer" }}></i> */}
                  <img
                    src={isFullScreen() ? ExitFullScreen : FullScreen}
                    onClick={() => {
                    toggleFullScreen();
                    setTimeout(() => {
                      forceUpdate({});
                    }, 100);
                    }}
                    alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                    className="toggle-icons"
                  />
                  <img
                    src={isDarkMode() ? LightMode : DarkMode}
                    onClick={() => {
                    toggleTheme();
                    forceUpdate({});
                    }}
                    alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                    className="toggle-icons"
                  />
                </div>
              </Row>
            </Row>

            {/* TestProgress - Same position as SectionalTest */}
            

            {/* Middle Content Section - Same as SectionalTest Section.jsx */}
            <div className="question-area-main mock-container mock-resource-text" style={{ paddingBottom: "200px" }}>
              <div style={{ padding: "20px 40px 40px" }}>
                {/* <p className="question-title-ext">
                  Question instruction title would go here
                </p>
                <hr /> */}
                <Row className="unselectable">
                  {isOnline ? (
                    <>
                      <QuestionInstruction
                        subcategoryId={questions[currentQuestion]?.subcategory_id}
                        qTitle={questions[currentQuestion]?.q_title}
                      />
                      <Question
                        question={questions[currentQuestion]}
                        props_data={props_data}
                        key={currentQuestion}
                      />
                    </>
                  ) : (
                    <>
                      <Skeleton
                        count={1}
                        width={"50%"}
                        height={200}
                        containerClassName="skeleton-wrapper__mockrecording"
                      />
                      <Skeleton
                        count={5}
                        width={"100%"}
                        containerClassName="skeleton-wrapper__mocklines"
                      />
                    </>
                  )}
                </Row>
              </div>
            </div>
          </Col>
          
          {/* BottomBtns - Same as SectionalTest */}
          <Col xs={12}>
            <div className="bottomBtns fixed-bottom-row mock-header-gap">
              <Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
                <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}>
                  {currentQuestion < questions.length - 1 && questions[currentQuestion].question_number !== 1 && (
                    <Button
                      color="primary"
                      onClick={(e) => next(SAVE_AND_EXIT)}
                      size="xs"
                      disabled={currentQuestion === 0}
                      className={`mock-btn bottomBtnFont d-flex align-items-center ${currentQuestion === 0 ? 'disable_btn' : 'mock-bottom-btn'}`}
                    >
                      Save & Exit
                    </Button>
                  )}
                </Col>
                <Col className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}></Col>
                <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}>
                  {currentQuestion < questions.length - 1 ? (
                    <Button
                      color="primary"
                      onClick={(e) => next(NEXT)}
                      size="xs"
                      className="mock-btn bottomBtnFont d-flex align-items-center"
                    >
                      NEXT
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      onClick={(e) => next(SUBMIT)}
                      size="xs"
                      className="mock-btn bottomBtnFont d-flex align-items-center"
                    >
                      Submit
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      
      {/* Original Card-based structure - commented out */}
      {/* <div className="content questionsArea">
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Header>
                <Row>
                  <Col xs={6}>
                    <Card.Title tag="h4">{mock.title}</Card.Title>
                  </Col>
                  <Col xs={6}>
                    <div className="text-right questionTime">
                      <CountdownTimer
                        time={time}
                        sectionTimedOut={sectionTimedOut}
                        reduceSectionTime={reduceSectionTime}
                        setReduceSectionTime={setReduceSectionTime}
                      />

                      <TestProgress
                        mockData={mockData}
                        questions={questions}
                        currentQuestion={currentQuestion}
                        pending={pending}
                        localPending={localPending}
                        skip={skip}
                      />
                    </div>
                  </Col>
                </Row>
              </Card.Header>

              <Card.Body>
                {isOnline ? (
                  <>
                    <QuestionInstruction
                      subcategoryId={questions[currentQuestion]?.subcategory_id}
                      qTitle={questions[currentQuestion]?.q_title}
                    />
                    <Question
                      question={questions[currentQuestion]}
                      props_data={props_data}
                      key={currentQuestion}
                    />
                  </>
                ) : (
                  <div className="offline-content">
                    <Skeleton count={1} width="50%" height={200} 
                              containerClassName="skeleton-wrapper__mockrecording" />
                    <Skeleton count={5} width="100%" 
                              containerClassName="skeleton-wrapper__mocklines" />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12}>
            <div className="bottomBtns">
              <Row>
                <Col xs={9}>
                  {currentQuestion < questions.length - 1 && questions[currentQuestion].question_number !== 1 && (
                    <Button
                      variant="primary"
                      onClick={(e) => next(SAVE_AND_EXIT)}
                      size="xs"
                    >
                      Save & Exit
                    </Button>
                  )}
                </Col>

                <Col xs={3}>
                  {currentQuestion < questions.length - 1 ? (
                    <Button
                      variant="primary"
                      onClick={(e) => next(NEXT)}
                      size="xs"
                    >
                      NEXT
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      onClick={(e) => next(SUBMIT)}
                      size="xs"
                    >
                      Submit
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div> */}

      <NextModal
        isOpen={nextModal}
        handler={setNextModal}
        submitResponse={submitResponse}
      />

      <WaitQuestionAudioFinish
        isOpen={questionAudioModal}
        handler={setQuestionAudioModal}
      />

      <SubmitSectionModal
        isOpen={submitSection}
        handler={setSubmitSection}
        submitResponse={submitResponse}
      />

      <SaveAndExitPopup
        isOpen={saveAndExitModal}
        handler={setSaveAndExitModal}
        saveTestAndExit={saveTestAndExit}
      />

      <TimeoutPopup
        isOpen={timeUp && skip < 3}
        endCurrentSectionAndStartNext={endCurrentSectionAndStartNext}
      />

      <NetworkDisconnected isOpen={!isOnline} />
    </>
  );
});

export default Questions;
